export { default } from "./StaticColorIndicator";
